import config from '../config'
import lightConfig from '../../light-config.json'
import createAlgoliaHelper from './createAlgoliaHelper'

type Category = {
  path: string
  level: number
  brand: string
  objectID: string
  label: string
  position: number
  filters: string[]
  seoTitle: string
  seoText: string
  dyCategoryPathId: string
  seo_attributes_updated_at: string
  hreflangData: Record<string, string>
}

let request: null | Promise<Category[]> = null

/**
 * Resolves a list of all categories in algolia. This is time-consuming
 * and should only be used server-side (plugins)
 */
export default async function fetchAllCategories(): Promise<Category[]> {
  if (request) return request
  request = doFetch()
  return request
}

async function doFetch() {
  const algoliaHelper = await createAlgoliaHelper(config.index.categories, {
    facets: ['active'],
    disjunctiveFacets: ['label'],
    attributesToHighlight: [],
    attributesToRetrieve: [
      'path',
      'level',
      'brand',
      'objectID',
      'label',
      'position',
      'filters',
      'hasSeries',
      'seoTitle',
      'seoText',
      'dyCategoryPathId',
      'seo_attributes_updated_at',
      'hreflangData'
    ]
  })

  const algoliaData: any = []
  let algoliaPage = 0

  algoliaHelper.addFacetRefinement('active', 'true')

  if (process.env.LIGHT_START) {
    for (const cat of lightConfig.categories)
      algoliaHelper.addDisjunctiveFacetRefinement('label', cat.key)
  }

  while (true) {
    algoliaHelper.setPage(algoliaPage)
    const result: any = await algoliaHelper.searchOnce({ hitsPerPage: 1000 })
    algoliaData.push(...result.content.hits)

    if (algoliaPage < result.content.nbPages) {
      algoliaPage++
    } else break
  }

  return algoliaData
}
